'use client';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import data from '../../../data/portfolios/workstand.json';
function Portfolio() {
  const [filteredData, setFilteredData] = useState(data);
  function filter(event, type) {
    document
      .querySelectorAll('.filter-btn')
      .forEach((item) => item.classList.remove('active'));
    // console.log(filters);
    event.currentTarget.classList.add('active');
    setFilteredData(data.filter((item) => item.subTitle === type));
  }
  return (
    <section className="work-minimal section-padding sub-bg">
      <div className="container-xxl">
        <div className="row">
          <div className="filtering col-12 mb-50 text-center">
            <div className="filter">
              <span className="text">Filter By :</span>
              <span onClick={() => setFilteredData(data)} className="active">
                Show All
              </span>
              <span
                className="filter-btn"
                onClick={(event) => filter(event, 'art')}
              >
                Art
              </span>
              <span
                className="filter-btn"
                onClick={(event) => filter(event, 'branding')}
              >
                Branding
              </span>
              <span
                className="filter-btn"
                onClick={(event) => filter(event, 'design')}
              >
                Design
              </span>
              <span
                className="filter-btn"
                onClick={(event) => filter(event, 'marketing')}
              >
                Marketing
              </span>
            </div>
          </div>
        </div>
        <div className="row stand-marg">
          {filteredData.map((item, i) => (
            <div key={i} className={`col-lg-4 col-md-6 items ${item.subTitle}`}>
              <div className="item mt-40">
                <div className="img">
                  <img src={item.img} alt="" />
                  <div className="cont d-flex align-items-center">
                    <div>
                      <h5 className="fz-22">
                        <a href={item.link}>{item.title}</a>
                      </h5>
                      <p>
                        <a href={item.link}>{item.subTitle.split(' ')[0]}</a>
                      </p>
                    </div>
                    <div className="ml-auto">
                      <a href={item.link} className="ti-arrow-top-right"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
